/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {VerifyContactsRequest} from '@cash-web/protos/squareup/franklin/app/contacts.pb'
import {VerifyContactsResponse} from '@cash-web/protos/squareup/franklin/app/contacts.pb'


export const verifyContacts = (request:VerifyContactsRequest, options?: CashRequestOptions) => post<VerifyContactsRequest, VerifyContactsResponse>("/2.0/cash/verify-contacts", request, {...options, rejectOnError: true })